import AddressData from './AddressData';

export default AddressData;
